import { useState, useEffect } from 'react'
import { DedicatedLane, useGetDedicatedLanesContracts } from 'apps/fleet-planner/types/apiTypes'

interface IDedicatedLanesApiState {
  dedicatedLanes: DedicatedLane[]
  isLoading: boolean
  setDedicatedLanes: any
}

export const useDedicatedLanesApi = (): IDedicatedLanesApiState => {
  const [dedicatedLanes, setDedicatedLanes] = useState<DedicatedLane[]>([])
  const { data, loading: isLoading } = useGetDedicatedLanesContracts({})

  useEffect(() => {
    setDedicatedLanes(data?.dedicatedLanes || [])
  }, [data])

  return {
    isLoading,
    dedicatedLanes,
    setDedicatedLanes,
  }
}
